/*
  EBG Info-meny (C4, graa linje)
  Oppforsel for snippets/ebg-info-menu.liquid. Ingen avhengigheter, lastes med defer.
  - Aapner nedtrekk ved hover/klikk, bare ett av gangen
  - Legger nedtrekket paa container-kanten, saa alle punkter aapner paa samme sted
  - Lukker 250 ms etter at musen forlater punktet, med Esc, klikk utenfor eller naar fokus forlater menyen
  - Kun aktiv paa desktop (min-width: 1025px, samme brekk som temaet)
*/
(function () {
  'use strict';

  var CLOSE_DELAY = 250;
  /* 1025 px = temaets lg-brekk, samme som CSS-en. Stod paa 1100 og lagde et
     doedt omraade mellom 1025 og 1099. */
  var mq = window.matchMedia('(min-width: 1025px)');

  function init(root) {
    if (root.hasAttribute('data-ebg-im-ready')) return;
    root.setAttribute('data-ebg-im-ready', '');

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ebg-im-item]')).filter(function (item) {
      return item.querySelector('[data-ebg-im-btn]') && item.querySelector('[data-ebg-im-dd]');
    });
    if (!items.length) return;

    var current = null;
    var closeTimer = null;

    function parts(item) {
      return {
        btn: item.querySelector('[data-ebg-im-btn]'),
        dd: item.querySelector('[data-ebg-im-dd]')
      };
    }

    /*
      Nedtrekket skal aapne paa samme sted uansett hvilket punkt som brukes,
      slik som den navy hovedmenyen. Uten dette starter hvert nedtrekk ved sin
      egen knapp: siste punkt ("Bli partner") havnet da utenfor vinduskanten og
      lagde vannrett rulling paa smale skjermer.
        left      = flyttes fra knappens venstrekant inn til container-kanten
        max-width = container-bredden, saa boksen aldri gaar utenfor
    */
    function layout(item) {
      var p = parts(item);
      if (p.dd.hidden) return;

      var cont = root.closest('.container');
      if (!cont) return;

      var contRect = cont.getBoundingClientRect();
      var cs = window.getComputedStyle(cont);
      var padLeft = parseFloat(cs.paddingLeft) || 0;
      var padRight = parseFloat(cs.paddingRight) || 0;
      var innerLeft = contRect.left + padLeft;
      var innerWidth = contRect.width - padLeft - padRight;
      var itemRect = item.getBoundingClientRect();

      p.dd.style.left = Math.round(innerLeft - itemRect.left) + 'px';
      p.dd.style.maxWidth = Math.floor(innerWidth) + 'px';
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function close() {
      cancelClose();
      if (!current) return;
      var p = parts(current);
      p.dd.hidden = true;
      p.btn.setAttribute('aria-expanded', 'false');
      current = null;
    }

    function open(item) {
      cancelClose();
      if (current === item) return;
      close();
      var p = parts(item);
      p.dd.hidden = false;
      p.btn.setAttribute('aria-expanded', 'true');
      current = item;
      layout(item);
    }

    items.forEach(function (item) {
      var p = parts(item);
      var openedAt = 0;

      item.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        if (current !== item) openedAt = Date.now();
        open(item);
      });

      item.addEventListener('mouseleave', function () {
        if (current !== item) return;
        cancelClose();
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });

      p.btn.addEventListener('click', function () {
        if (!mq.matches) return;
        // Hover aapnet nedtrekket akkurat, saa klikket skal ikke lukke det igjen
        if (current === item && Date.now() - openedAt < 400) return;
        if (current === item) {
          close();
        } else {
          open(item);
        }
      });
    });

    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && current && !current.contains(e.relatedTarget)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!current || (e.key !== 'Escape' && e.key !== 'Esc')) return;
      var btn = parts(current).btn;
      var hadFocus = current.contains(document.activeElement);
      close();
      if (hadFocus) btn.focus();
    });

    document.addEventListener('click', function (e) {
      if (current && !current.contains(e.target)) close();
    });

    window.addEventListener('resize', function () {
      if (current) layout(current);
    });

    var onMqChange = function () {
      if (!mq.matches) close();
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onMqChange);
    } else if (mq.addListener) {
      mq.addListener(onMqChange);
    }
  }

  function start() {
    document.querySelectorAll('[data-ebg-im]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Temaeditoren laster seksjoner paa nytt
  document.addEventListener('shopify:section:load', start);
})();
